"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
/**
 * @deprecated use {@link WCAGRadioButton} instead.
 */
class TypedRadioButtonWrapper extends InputWidget_1.default {
    constructor({ value, input, inputLabel, enabled = true, selected = false }) {
        super(input);
        this.enabled = enabled;
        if (!input || !inputLabel) {
            throw new Error("Input and Label need to be present when using TypedRadioButtonWrapper");
        }
        if (selected) {
            this._input.checked = true;
        }
        if (!this.enabled) {
            this.setEnabled(false);
        }
        this.setValue(value);
    }
    setValue(value) {
        // super uses FireIfEqual, we always want to fire, so that the valueChangeHandler is fired
        super.setValue(value, false);
        this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(value));
    }
    decorateElement(element) {
        element.type = "radio";
        element.style.margin = "0 8px 0 0";
    }
    setValueOnInput(value, input) {
        // Do nothing
    }
    parseValueFromInput(inputValue) {
        return this.value;
    }
}
exports.default = TypedRadioButtonWrapper;
//# sourceMappingURL=TypedRadioButtonWrapper.js.map